import React from 'react';

import { AttentionCircleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { queryClient } from '@vlabs/api';
import { useGetList } from '@vlabs/api/luna-api/client';
import type {
  ListId,
  // CardId,
} from '@vlabs/api/point-api/model';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './DetachCardFromListConfirmation.module.sass';

export interface DetachCardFromListConfirmationProps extends WithDataTestid {
  listId: ListId;
  // cardId: CardId;
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

const displayName = 'DetachCardFromListConfirmation';
const testid = buildTestid(displayName);

export function DetachCardFromListConfirmation({
  listId,
  // cardId,
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: DetachCardFromListConfirmationProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const getList = useGetList(listId, undefined, queryClient);

  if (!getList.isFetched) return null;

  const listName = getList.data?.user_data ?? getList.data?.list_id;

  return (
    <div
      className={st.Root}
      {...testid(dataTestId)}
    >
      <AttentionCircleIcon className={st.Icon} />

      <h5 className={st.Title}>
        {t('card-page:delete.list.title', { listName })}
      </h5>

      <div className={st.Message}>
        {t('card-page:delete.list.message', { listName })}
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          data-testid="utton-faceCard.confirmCancellButton"
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('btn.cancel')}
        </Control.Button>

        <Control.Button
          className={st.Action}
          data-testid="Button-faceCard.confirmDeleteButton"
          kind="attention"
          onClick={onConfirm}
        >
          {t('btn.exclude')}
        </Control.Button>
      </div>
    </div>
  );
}
